import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/authSlice';

const RoleRoute = ({ children, allowedRoles }) => {
  const user = useSelector(selectUser);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    // Redirect based on user's actual role
    const redirects = {
      customer: '/',
      seller: '/seller/dashboard',
      admin: '/admin/dashboard',
    };
    return <Navigate to={redirects[user.role] || '/'} replace />;
  }

  // Prevent unapproved sellers from accessing non-onboarding seller pages
  if (
    user.role === 'seller' &&
    user.seller &&
    user.seller.onboarding_status !== 'approved' &&
    !window.location.pathname.startsWith('/seller/onboarding')
  ) {
    return <Navigate to="/seller/onboarding/status" replace />;
  }

  return children;
};

export default RoleRoute;